import { useAuth } from '@/core/auth/auth';
import type { SubscriptionInfo } from '@/core/auth/auth-state';

/**
 * Hook to access subscription state from the bootstrap response.
 * Returns null if no active subscription exists.
 */
export function useSubscription() {
  const { bootstrap } = useAuth();

  const subscription: SubscriptionInfo | null = bootstrap?.subscription ?? null;
  const isSubscribed = subscription?.status === 'active';
  const isCanceling = subscription?.cancel_at_period_end === true;

  return {
    subscription,
    isSubscribed,
    isCanceling,
    planName: subscription?.plan_name ?? null,
    planId: subscription?.plan_id ?? null,
    currentPeriodEnd: subscription?.current_period_end ?? null,
  };
}
